/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { PanelBody } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './scss/editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit( { attributes, setAttributes, clientId } ) {

	const isEmpty = useSelect(
		(select) => {
			const innerBlocks = select('core/block-editor').getBlocks(clientId);
			return innerBlocks.length === 0;
		},
		[clientId]
	);
	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Slide settings', 'eo-blocks' ) }>
				</PanelBody>
			</InspectorControls>

			<div { ...useBlockProps() }>
				<div className="eo-slide__inner">
					<InnerBlocks
						renderAppender={() =>
							isEmpty ? <InnerBlocks.ButtonBlockAppender /> : null
						}
					/>
				</div>
			</div>
		</>
	);
}
